import { useCallback } from "react";
import { useSelector } from "react-redux";

import { DynamicAutocompleteField } from "components/formFields/DynamicAutocompleteField";
import { LineSelectPopper } from "components/formFields/LineSelectPopper";
import { LineTableCell } from "components/formFields/LineTableCell";

import { makeLineItemRenderInput } from "services/utility/autocomplete";
import { fetchClasses } from "services/utility/class";

export function LineClass(props) {
  const {
    value,
    classes,
    classesCount,
    onValueChange,
    lineReadOnly = false,
  } = props;

  const classEnabled = useSelector(
    (state) => state.userCompanySettings.settings.classEnabled
  );

  const renderInput = useCallback(
    (params) => makeLineItemRenderInput(value)(params),
    [value]
  );

  if (!classEnabled) {
    return null;
  }

  return (
    <LineTableCell sx={{ minWidth: "13rem" }}>
      <DynamicAutocompleteField
        fullWidth
        name="class"
        options={classes}
        optionsCount={classesCount}
        fetchFn={fetchClasses}
        value={value}
        onValueChange={onValueChange}
        lineReadOnly={lineReadOnly}
        PopperComponent={LineSelectPopper}
        renderInput={renderInput}
      />
    </LineTableCell>
  );
}
